module.exports = __webpack_public_path__ + "img/logo-phire.1636fc21.png";